"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const AppBar_1 = tslib_1.__importDefault(require("@mui/material/AppBar"));
const Toolbar_1 = tslib_1.__importDefault(require("@mui/material/Toolbar"));
const PageHeader = (props) => {
    const { size = "normal", content, classes, AppBarProps, className, ...toolbarPropsProp } = props;
    const appBarProps = {
        color: "inherit",
        elevation: 4,
        ...AppBarProps,
        /* Its not possible to override the sticky position */
        position: "sticky",
        sx: { p: 0 }
    };
    const toolbarProps = {
        ...toolbarPropsProp,
        sx: size === "large" ? {
            minHeight: theme => ({ xs: Math.round(Number(theme.mixins.toolbar.minHeight) * 1.5) })
        } : {}
    };
    return (react_1.default.createElement(AppBar_1.default, { ...appBarProps },
        react_1.default.createElement(Toolbar_1.default, { ...toolbarProps }, content)));
};
exports.default = PageHeader;
